// components/GenerateUserToken.js
import React, { useState } from 'react';
import { API_URL } from '../reusable/url';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import './generateUserToken.css'

const GenerateUserToken = () => {
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const authToken = useSelector((state) => state.user.token);

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch(API_URL('generate-user-token'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        if (data.token) {
          setToken(data.token);
          toast.success('Token generated successfully!');
        } else {
          toast.error('Failed to generate token');
        }
      })
      .catch(err => {
        toast.error('Failed to generate token');
        console.error(err);
      });
  };

  const handleEmailSend = () => {
    window.open(`mailto:${email}?subject=P-score App User Registration Token&body=Here is your registration token for P-score app: ${token}`);
  };

  return (
    <div className="user-registration-container">
      <h2>Generate User Registration Token</h2>
      <form onSubmit={handleSubmit}>
        <Box sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}>
          <TextField 
            required
            id="outlined-required-email"
            label="User Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            color="secondary"
            focused
            InputLabelProps={{ style: { color: 'darkviolet' } }}
            sx={{
              input: { color: 'navy' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'darkviolet' },
                '&:hover fieldset': { borderColor: 'darkviolet' },
                '&.Mui-focused fieldset': { borderColor: 'darkviolet' },
              },
            }}
          />
        </Box>
        <button type="submit" className="btn-generate-user-token">Generate Token</button>
      </form>
      {token && (
      <Box sx={{ margin: 2, padding: 2, border: '1px solid navy', borderRadius: '5px', backgroundColor: 'whitesmoke' }}>

          <h3>Token:</h3>
          <p style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>{token}</p>
          <button className="btn-send-token" onClick={handleEmailSend} >Send Token via Email</button>
        </Box>
      )}
    </div>
  );
};

export default GenerateUserToken;
